import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Button from '@mui/material/Button';

// nextButton property will override bgcolor for affected element
const theme = createTheme({
    palette: {
        nextButton: {
            main: '#3d3d3d',
            light: '#D9D9D9'
        }
    },
});

/*
params @bigButton
        if true, set width to 160px
params @text
        the title for the button
params @click
        perform the click event
params @skip
        if set to true, button bgcolor will be lighter
*/

const MuiButton = ({ bigButton, text, skip, click, startIcon, endIcon, bgColor, hoverColor, isLoading, extraBigButton, ...rest }) => {
    return (
        <ThemeProvider theme={theme}>
            <Button variant='contained' sx={{
                bgcolor: bgColor && !skip ? bgColor : !bgColor && skip ? 'nextButton.light' : 'nextButton.main',
                height: '48px',
                color: 'white',
                fontWeight: 600,
                textTransform: 'uppercase',
                border: skip ? null : `1px solid ${bgColor ? bgColor : '#3d3d3d'}`,
                padding: '0 20px',
                fontFamily: "Josefin Sans",
                letterSpacing: '0.32px',
                borderRadius: '9px',
                cursor: 'pointer',
                fontSize: { xs: text.length > 6 ? '12px' : '16px', md: '16px' },
                maxWidth: '100%',
                width: bigButton ? '160px' : extraBigButton ? '200px' : '',
                '&:hover': { bgcolor: hoverColor && !skip ? hoverColor : !hoverColor && skip ? 'nextButton.light' : 'nextButton.main', }
            }}
                {...rest}
                startIcon={startIcon ? startIcon : ''}
                endIcon={endIcon ? endIcon : ''}
                onClick={click}
            >

                {isLoading ? isLoading : text}
            </Button>
        </ThemeProvider>
    );
};

export default MuiButton;